import Vue from 'vue';
// import './plugins/attach';

import AsyncComputed from 'vue-async-computed';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

import GAuth from './plugins/GoogleApi.js';

Vue.use(AsyncComputed);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

const gauthOption = {
  clientId: '527833862692-loq5hh8di98u1ckhifls06q1ukts6emn.apps.googleusercontent.com',
  scope: 'https://www.googleapis.com/auth/drive.file'
}
Vue.use(GAuth, gauthOption);

import PiggyBank from './services/piggybank.service.js';
Vue.use(PiggyBank, {
  appName: 'PiggyBank'
});

import Tools from './services/tools.service';
Vue.use(Tools);

import DynamicComponent from './services/dynamic.component.service';
Vue.use(DynamicComponent);

Vue.config.productionTip = false;

import { library } from '@fortawesome/fontawesome-svg-core';
import { faMoneyBillWave, faPencilAlt, faTrashAlt, faPlus, faSave, faSyncAlt, faUser, faSpinner, faCalendarAlt, faWrench, faCalendarPlus, faCalendarTimes, faCommentDollar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faMoneyBillWave, faPencilAlt, faTrashAlt, faPlus, faSave, faSyncAlt, faUser, faSpinner, faCalendarAlt, faWrench, faCalendarPlus, faCalendarTimes, faCommentDollar);
Vue.component('font-awesome-icon', FontAwesomeIcon);
// import '../node_modules/@fortawesome/fontawesome-free/css/fontawesome.css';
// import './scss/fontawesome.scss';
// import '@fortawesome/fontawesome-free/css/fontawesome.css';
// import 'animate.css';


import Vue2TouchEvents from 'vue2-touch-events';
Vue.use(Vue2TouchEvents);

import './scss/piggybank.scss';
import '../node_modules/colorex/dist/colorex.min.css';
import './filters/month';
import './filters/currency';
import './filters/date';
import './components';
import './pwa/pwa';

import router from './router';
import store from './stateManagement/stateManagement';
import i18n from './i18n/i18n';
import App from './App.vue';

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');